// Portuguese translation

const pt = {
  "hotel.booking.number": "Número",
  "hotel.booking.party": "Titular",
  "hotel.booking.contact": "Contato",
  "hotel.booking.bill_to": "Faturar para",
  "hotel.booking.bill.all": "Tudo",
  "hotel.booking.bill.partial": "Parcial",
  "hotel.booking.booking_date": "Data da reserva",
  "hotel.booking.total_amount": "Valor total",
  "hotel.booking.total_advances": "Total de adiantamentos",
  "hotel.booking.lines": "Nº de quartos",
  "hotel.booking.media": "Canal",
  "hotel.booking.meal_plan": "Plano de refeições",
  "hotel.booking.space": "Espaço",
  "hotel.booking.price_list": "Lista de preços",
  "hotel.booking.payment_term": "Prazo de pagamento",
  "hotel.booking.rate_plan": "Plano tarifário",
  "hotel.booking.pending_to_pay": "Pendente de pagamento",
  "hotel.booking.group": "Grupo",
  "hotel.booking.corporative": "Corporativo",
  "hotel.booking.state": "Status",
  "hotel.booking.offer": "Oferta",
  "hotel.booking.complimentary": "Cortesia",
  "hotel.booking.confirm": "Confirmar",
  "hotel.booking.cancelled": "Cancelado",
  "hotel.booking.no_show": "Não compareceu",
  "hotel.booking.block": "Bloquear",
  "hotel.booking.finished": "Finalizado",
  "hotel.booking": "RESERVA",
  "hotel.booking.today": "Hoje",
  "hotel.booking.confirmed": "Confirmada",
  "hotel.booking.bill": "Faturar",
  "hotel.booking.channel": "Canal",
  "hotel.booking.ota_booking_code": "Código OTA",
  "hotel.booking.agent": "Agente",
  "hotel.booking.notes": "Notas",
  "hotel.booking.advances_payments": "Adiantamentos / Pagamentos",
  "hotel.booking.invoices": "Faturas",
  "hotel.booking.notifications": "Notificações",
  "hotel.booking.pax": "PAX",
  "hotel.booking.taxes_exception": "Isenção de IVA",
  "hotel.booking.holder": "Titular",
  "hotel.booking.holder_guest": "Titular / Hóspede",
  "hotel.booking.guest": "Hóspede",
  "hotel.booking.blocked": "Bloqueado",
  "hotel.folio": "FÓLIO",
  "hotel.booking.lead_origin": "Origem",
  "hotel.folio.overbooking": "Overbooking",
  "hotel.folio.accept": "Aceitar",
  "hotel.booking.add_rooms": "Adicionar quarto",
  "hotel.booking.add_rooms.accept": "Aceitar",
  "hotel.booking_statement": "PRÉ-CONTA",
  "hotel.booking.plan+rate": "Plano + tarifas sem impostos",
  "hotel.booking.fees_taxes_not_included": "ENCARGOS E IMPOSTOS NÃO INCLUÍDOS",
  "hotel.booking.msg_iva_foreign":
    "IVA não incluído para estrangeiros, mediante verificação do passaporte e do cartão migratório no check-in.",
  "hotel.booking.msg_iva": "IVA incluído de 19%.",
  "hotel.booking.i_foreigner": "Sou estrangeiro",
  "hotel.booking.i_colombiano": "Sou colombiano",
  "hotel.booking.add_rooms.selector.product": "Categoria",
  "hotel.booking.add_rooms.selector.unit_price_w_tax": "Tarifa",
  "hotel.booking.add_rooms.selector.available": "Disponíveis",
  "hotel.booking.add_rooms.selector.adults": "Adultos",
  "hotel.booking.add_rooms.selector.children": "Crianças",
  "hotel.booking.add_rooms.selector.room": "Quarto",
  "hotel.booking.add_rooms.selector.add": "Adicionar",
  "hotel.booking.add_rooms.selector.sale_price_taxed": "Preço",
  "hotel.booking.add_rooms.selector.discount": "Desconto",
  "hotel.booking.add_rooms.nights_quantity": "Noites",
  "hotel.booking.add_payment": "Adiantamento / Pagamento",
  "hotel.booking.add_payment.amount": "Valor",
  "hotel.booking.add_payment.voucher": "Comprovante",
  "hotel.booking.add_payment.statement": "Meio de pagamento",
  "hotel.booking.add_payment.pay": "Pagar",
  "hotel.booking.add_room.arrival_date": "Chegada",
  "hotel.booking.add_room.departure_date": "Saída",
  "hotel.booking.add_room.nights_quantity": "Noites",
  "hotel.booking.add_rooms.selector.rooms": "Quartos",
  "hotel.chart.occupation_room": "Ocupação dos quartos",
  "hotel.chart.occupation_today": "Hoje",
  "hotel.chart.occupation_tomorrow": "Amanhã",
  "hotel.chart.check_in_today": "Check-in hoje",
  "hotel.chart.check_out_today": "Check-out hoje",
  "hotel.chart.occupation_rate": "Taxa de ocupação",
  "hotel.chart.occupation_rate_today": "Hoje",
  "hotel.chart.occupation_rate_tomorrow": "Amanhã",
  "hotel.booking.bill.party": "Terceiro",
  "hotel.booking.bill.kind": "Tipo",
  "hotel.booking.bill.bill": "Faturar",
  "hotel.booking.bill.add_guest": "Adicionar hóspede",
  "hotel.booking.bill.add_vehicle_plate": "Adicionar placa",
  "hotel.booking.wiz_payment.voucher": "Comprovante",
  "hotel.booking.wiz_payment.statement": "Meio de pagamento",
  "hotel.booking.wiz_payment.amount": "Valor",
  "hotel.booking.wiz_payment.notes": "Notas",
  "booking.widget_side.today": "Hoje",
  "booking.widget_side.tomorrow": "Amanhã",
  "booking.widget_side_status.revenue_today": "Receita hoje",
  "hotel.booking.wiz_payment.button_pay": "Pagar",
  "hotel.booking.undefined": "Indefinido",
  "hotel.booking.environment": "Ambiente",
  "hotel.booking.update_taxes": "Atualizar impostos",
  "hotel.booking.update_taxes.start.accept": "Aceitar",
  "hotel.booking.update_taxes.start.taxes": "Impostos",
  "hotel.booking.apply_taxes_exception": "Isenção de IVA",
  "hotel.booking.add_rooms.selector.accommodation": "Acomodação",
  "hotel.booking.add_rooms.selector.availability": "Disponibilidade",
  "hotel.booking.whitout.rooms":
    "Não há quartos disponíveis para as datas selecionadas",
  "hotel.booking.kids.policy": "Política para crianças",
};

export default pt;
